import React from "react";

import styled from "@emotion/styled";

const TextIcon = ({ color = "#E1E1E1", hoverColor = color }) => {
    const SVG = styled.svg`
        fill: ${color};

        &:hover {
            fill: ${hoverColor};
        }
    `;
    return (
        <svg
            id="Gruppe_7405"
            data-name="Gruppe 7405"
            xmlns="http://www.w3.org/2000/svg"
            width="19.188"
            height="18"
            viewBox="0 0 19.188 18"
        >
            <g
                id="Gruppe_7404"
                data-name="Gruppe 7404"
                transform="translate(4.975 4)"
            >
                <rect
                    id="Rechteck_1652"
                    data-name="Rechteck 1652"
                    width="4.975"
                    height="1"
                    rx="0.5"
                    transform="translate(0 6)"
                    fill="#05235f"
                />
                <rect
                    id="Rechteck_2157"
                    data-name="Rechteck 2157"
                    width="6.964"
                    height="1"
                    rx="0.5"
                    transform="translate(0 3)"
                    fill="#05235f"
                />
                <rect
                    id="Rechteck_2158"
                    data-name="Rechteck 2158"
                    width="8.954"
                    height="1"
                    rx="0.5"
                    transform="translate(0)"
                    fill="#05235f"
                />
            </g>
            <path
                id="message-regular-full"
                d="M71.125,112.907h0l-1.322.939a.841.841,0,0,1-1.326-.689v-2.531H67.358A3.367,3.367,0,0,1,64,107.25V99.375A3.367,3.367,0,0,1,67.358,96H79.83a3.367,3.367,0,0,1,3.358,3.375v7.875a3.367,3.367,0,0,1-3.358,3.375H74.34Zm2.249-3.66a1.681,1.681,0,0,1,.969-.309H79.83a1.684,1.684,0,0,0,1.679-1.688V99.375a1.684,1.684,0,0,0-1.679-1.688H67.358a1.684,1.684,0,0,0-1.679,1.688v7.875a1.684,1.684,0,0,0,1.679,1.688h1.959a.842.842,0,0,1,.839.844v1.747l3.215-2.282Z"
                transform="translate(-64 -96)"
                fill="#0e235f"
            />
        </svg>
    );
};

export default TextIcon;
